import { modules } from "../../main";

interface GlobalThis {
    s20_KundenGruppenNr: string;
    sB_Kunde_ZahltKeineUst: string;
    sKontaktUST: string;
    sL_Lieferlandid: string;
    hLandid: string;
    s20_Kundennr: string;
    sKundenID: string;
}

declare var globalThis: GlobalThis;

// Assigning variables from globalThis safely
export abstract class CaspardoAPI {
    private static s20_KundenGruppenNr = globalThis.s20_KundenGruppenNr ?? '';
    private static sB_Kunde_ZahltKeineUst = globalThis.sB_Kunde_ZahltKeineUst ?? '';
    private static sKontaktUST = globalThis.sKontaktUST ?? '';
    private static sL_Lieferlandid = globalThis.sL_Lieferlandid ?? '';
    private static hLandid = globalThis.hLandid ?? '';
    private static s20_Kundennr = globalThis.s20_Kundennr ?? '';
    private static sKundenID = globalThis.sKundenID ?? '';

    public static async getSuggestions(api_url: string, sid: string, inputString: string, UUID: string, mandant_id: string, signal: any) {
        let url = `${api_url}hid=${mandant_id}&queryword=${encodeURIComponent(inputString)}&language=${modules.getLanguageCode()}&showplan=1&emulation=1`;

        if (UUID !== '') url += `&uuid=${UUID}`;

        url += `&LQ_keinUst=${CaspardoAPI.sB_Kunde_ZahltKeineUst}`;
        url += `&LQ_kontaktUst=${CaspardoAPI.sKontaktUST}`;
        url += `&LQ_KundenId=${CaspardoAPI.sKundenID}`;
        url += `&LQ_lieferlandId=${CaspardoAPI.sL_Lieferlandid}`;
        url += `&LQ_landId=${CaspardoAPI.hLandid}`;

        if (CaspardoAPI.s20_Kundennr !== '') url += `&LQ_KundenNr=${CaspardoAPI.s20_Kundennr}`;
        if (CaspardoAPI.s20_KundenGruppenNr !== '') url += `&LQ_KundenGruppe=${CaspardoAPI.s20_KundenGruppenNr}`;

        try {
            const response = await fetch(url, { signal });

            if (response.ok) {
                if (signal && signal.aborted) {
                    return { autocomplete: [] };
                }

                const data = await response.json();
                return data;
            } else {
                throw new Error(`Request failed with status ${response.status}`);
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted:', error.message);
            } else {
                console.error('Error in fetch:', error);
            }
            throw error;
        }
    }
}
